import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { default as MuiCardContent } from '@material-ui/core/CardContent';
export var useStyles = makeStyles(function () {
    return createStyles({
        collapseTop: {
            paddingTop: 0,
        },
        collapseBottom: {
            paddingBottom: 0,
        },
        collapseVertical: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        collapseLeft: {
            paddingLeft: 0,
        },
        collapseRight: {
            paddingRight: 0,
        },
        collapseHorizontal: {
            paddingLeft: 0,
            paddingRight: 0,
        },
        collapseAll: {
            padding: 0,
        },
    });
});
export var CardContent = React.forwardRef(function (props, ref) {
    var _a;
    var className = props.className, collapse = props.collapse, other = __rest(props, ["className", "collapse"]);
    var classes = useStyles(props);
    return (React.createElement(MuiCardContent, __assign({ ref: ref, className: clsx(className, (_a = {},
            _a[classes.collapseTop] = collapse === 'top',
            _a[classes.collapseBottom] = collapse === 'bottom',
            _a[classes.collapseVertical] = collapse === 'vertical',
            _a[classes.collapseLeft] = collapse === 'left',
            _a[classes.collapseRight] = collapse === 'right',
            _a[classes.collapseHorizontal] = collapse === 'horizontal',
            _a[classes.collapseAll] = collapse === 'all',
            _a)) }, other)));
});
export default CardContent;
//# sourceMappingURL=CardContent.js.map